<template>
    <div class="to-pay">
        <h3>剩余支付时间：{{min}}:{{sec}}</h3>
        <div class="trade-info">
            <h4><span>￥</span>{{real_money}}</h4>
            <p>订单号：{{orderNum}}</p>
        </div>

        <!-- <mt-radio class="wechat" v-model="value" :options="['微信支付']" align="right" value="说明文字"></mt-radio> -->

        <div v-if="real_money > 0" class="radio-item" :class="item.class" v-for="(item, index) in options" :key="index">
            <label :for="item.class">{{item.name}} <!-- <span v-if="item.serve">服务费{{item.serve}}</span> --></label>
            <!-- <div class="inp-wrapper">
                <input type="radio" name="payway" :id="item.class" v-model="value" :value="item.name">
                <span class="mint-radio-core"></span>
            </div> -->
        </div>

        <button @click="callLllwWxPay()">确认提交￥{{real_money}}</button>
        <button class="contact" @click="cancel_pay()">取消支付</button>
    </div>
</template>
<script>
const wx = require('weixin-js-sdk');
const timer = null;
export default {
    data () {
        return {
            leftTime: '29:59',
            real_money:'',
            orderNum:'',
            tradeId: '15467842310324651fdbh54545',
            serviceTip: '10%',
            value: '', // 单选框选中的值
            options: [ // 单选框列表
                {
                    class: 'wechat',
                    name: '微信支付',
                    serve: '0.08'
                }
            ],
            appid:'',
            secret:'',
            userId:'',
            orderId:'',
            v_token:'',      //注: 常住房间所在小区token, 非订单所属小区token
            fee_token:'',    //订单所属小区token
            s_type:'',
            openId:'',
            min: '',
            sec: '', // 倒计时时间
        }
    },
    created(){
        if(!this.$route.query.orderId || this.$route.query.orderId == 'undefined'){
            history.go(-1);
        }else{
            this.userId = this.$route.query.userId;
            this.orderId = this.$route.query.orderId;
            this.v_token = this.$route.query.v_token;
            this.s_type = this.$route.query.s_type;
            this.getPaidInfo();
        }
    },
    watch: {
        sec () {
            if(this.min == 0 && this.sec != 0){
                setTimeout(()=>{
                    this.sec--;
                }, 1000);
            }else if(this.min != 0){
                setTimeout(()=>{
                    this.sec--;
                    if(this.sec <= 0){
                        this.sec = 60;
                        this.min--;
                    }
                }, 1000);
            }
            
            // if(this.min == '0' || this.min == '00'){
            //     if(this.sec != '0' || this.sec != '00'){
            //         setTimeout(()=>{
            //             this.sec--;
            //         }, 1000);
            //     }else{
            //         this.sec == '00';
            //     }
            // }else if(this.min != '0' || this.min != '00'){
            //     setTimeout(()=>{
            //         this.sec--;
            //         if(this.sec <= 0){
            //             this.sec = '60';
            //             this.min--;
            //         }
            //     }, 1000);
            // }
        }
        // min () {
        //     if(this.min == '0'){
        //         this.min == '00';
        //     }
        // }
    },
    methods:{
        getPaidInfo(){//已经提交订单，获取订单详情
              let params = '';
              params = '/order_id/'+this.orderId+'/s_type/' + this.s_type +'/user_id/' + this.userId + '/token/' + this.v_token;
              let url = '/jmobile/WxPropertyFeeHistory/detail';
              this.axios.get(url+params).then((res)=>{

                   if(res.data.status == '1'){
                       
                      this.detail_array = res.data.data.detail_array;
                      this.owner_str = res.data.data.owner_str;
                      this.real_money = res.data.data.real_money;
                      this.orderNum = res.data.data.info.order_number;
                      this.fee_token = res.data.data.info.token;
                      this.getCountDown();
                      this.getWxPayConfig();
                      
                    }else{
                      this.$toast({
                          message:res.data.info,
                          position:'bottom',
                          duration:'2000'
                      });
                   }
              }).catch((res)=>{
                  this.$toast({
                     message:'网络错误',
                     position:'bottom',
                     duration:'2000'
                  })
              });
        },
        getCountDown(){ // 获取剩余时间
            let url = '/jmobile/MobileCommonFunction/count_down';
            let params = {type_id:'4','order_id':this.orderId};
            params = JSON.stringify(params);
            // this.min = '30';
            // this.sec = '00';
            this.axios.get(url +'/json/'+params).then((res)=>{
                if(res.data.status == '1'){
                    console.log(res)
                    this.min = res.data.data.min;
                    this.sec = res.data.data.sec;
                }else{
                    this.$toast({
                        message:res.data.info,
                        position:'bottom',
                        duration:'2000'
                    });
                }
              }).catch((res)=>{
                  this.$toast({
                     message:'网络错误',
                     position:'bottom',
                     duration:'2000'
                  })
              });
        },


        //动态获取微信信息配置
        getWxPayConfig(){
            this.axios.get('/jmobile/WxApi/getWxPayConfig/token/'+this.fee_token+'/pay_type/4').then((res)=>{
                if(res.data.status == '1'){
                    this.appid = res.data.data.jsapi_app_id;
                    this.secret = res.data.data.jsapi_secret;
                    this.auth();
                }else{
                  
                      this.$toast({
                         message:res.data.info,
                         position:'bottom',
                         duration:'2000'
                      });
                }
            }).catch((res)=>{
                   this.$toast({
                       message:'网络错误1',
                       position:'bottom',
                       duration:'2000'
                   });
            });
        },

        auth(){
          //走静默授权获取openId,公众号支付用

            this.redirect_uri = 'https://wx.loulilouwai.com.cn/#/ToPay?orderId='+this.$route.query.orderId+'&userId='+this.$route.query.userId+'&v_token='+this.$route.query.v_token+'&s_type='+this.$route.query.s_type;
            this.redirect_uri =  this.urlencode(this.redirect_uri);
          
            let uri_params = this.getRequest();
            let code = uri_params['code'];
            
            if(typeof(code) == 'undefined' ){
             
               var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+this.appid+'&redirect_uri='+this.redirect_uri+'&response_type=code&scope=snsapi_base&state=124#wechat_redirect';
                window.location.href = url;
            }else{
              this.getToken(code);
            }
        },

        getToken(code){
            let url = 'sns/oauth2/access_token?appid='+this.appid+'&secret='+this.secret+'&code='+code+'&grant_type=authorization_code';
              this.axios.get(url).then((res)=>{
                  // console.log(res);
                  this.openId = res.data.openid;
              }).catch((response)=>{
                    this.$toast({
                      message:'网络错误2',
                      position:'bottom',
                      duration:'2000'
                    });
              });
        },

        cancel_pay(){
            history.go(-2);
        },
        callLllwWxPay(){
            if(!this.openId){
                this.$toast({
                    message:'暂时无法支付',
                    position:'bottom',
                    duration:'2000'
                });
            }
            let qs = require('querystring');
            //let notify_url = 'https://loulilouwai.net/loulilouwai/Jmobile/PropertyFeeWeixin/buy/user_id/'+localStorage.getItem('userId')+'/token/'+this.v_token+'/order_id/'+this.orderId+'/pay_type/4';
              let notify_url = 'https://loulilouwai.net/loulilouwai/Jmobile/PropertyFeeWeixin/buy_weixin/user_id/'+this.userId+'/token/'+this.fee_token+'/order_id/'+this.orderId+'/pay_type/4/is_share/true';
             
                    let data={'out_trade_no':this.orderId,'total_fee':this.real_money,'token':this.fee_token,'body':'楼里楼外物业费支付'+this.orderId,'is_share':'true','pay_type':'4','notify_url':notify_url,'openId':this.openId};
                      data = qs.stringify(data);
                    this.axios.post('/jmobile/PaymentWeixin/lists',data).then((res)=>{
                          if(res.data.status == '1'){
                              this.wx_config = res.data.data;
                              this.pay();
                          }else{
                              this.$toast({
                                  message:'操作有误,请退出重新提交',
                                  position:'bottom',
                                  duration:'2000'
                              });
                          }
                    }).catch((res)=>{
                          this.$toast({
                             message:'网络错误123',
                             position:'bottom',
                             duration:'2000'
                          });
                    });
        },
        pay(){
            /*
                if (typeof WeixinJSBridge == "undefined"){
                    if( document.addEventListener ){
                        document.addEventListener('WeixinJSBridgeReady',this.onBridgeReady, false);
                    }else if (document.attachEvent){
                        document.attachEvent('WeixinJSBridgeReady',this.onBridgeReady);
                        document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                    }
                }else{
                    this.onBridgeReady();
                }*/
            
            wx.config({
                    debug:false,
                    appId:this.wx_config.appId,
                    timestamp:this.wx_config.timeStamp,
                    nonceStr:this.wx_config.nonceStr,
                    signature:this.wx_config.paySign,
                    jsApiList:['chooseWXPay']
            });
            
                wx.ready(()=>{
                    
                    wx.chooseWXPay({
                        timestamp:this.wx_config.timeStamp,
                        nonceStr:this.wx_config.nonceStr,
                        package:this.wx_config.package,
                        signType:'MD5',
                        paySign:this.wx_config.paySign,
                        
                        success:(res)=>{
                           this.$router.push({'name':'SuccessPay',query:{'orderId':this.$route.query.orderId}});
                        },
                        fail:(res)=>{
                            MessageBox.alert('缴费失败','提示');
                        }
                    });
                });
               
                // wx.error(function(res){
                //     console.log('err_msg:'+res);
                // });
        },
        onBridgeReady(){
             WeixinJSBridge.invoke(
               'getBrandWCPayRequest', this.wx_config,
               function(res){     
                   if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                        console.log(res);
                   }     // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。 
               }
           ); 
        },

        getRequest(){
           let url = location.search;
           let theRequest = new Object();
           if(url.indexOf('?') != -1){
               let str = url.substr(1);
               let strs = str.split('&');
               for(let i=0;i<strs.length;i++){
                  theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
               }
           }
           return theRequest;
        },

        urlencode(clearString){
              var output = '';
              var x = 0;
               
              clearString = utf16to8(clearString.toString());
              var regex = /(^[a-zA-Z0-9-_.]*)/;
           
              while (x < clearString.length) 
              {
                  var match = regex.exec(clearString.substr(x));
                  if (match != null && match.length > 1 && match[1] != '') 
                  {
                      output += match[1];
                      x += match[1].length;
                  } 
                  else
                  {
                      if (clearString[x] == ' ')
                          output += '+';
                      else
                      {
                          var charCode = clearString.charCodeAt(x);
                          var hexVal = charCode.toString(16);
                          output += '%' + ( hexVal.length < 2 ? '0' : '' ) + hexVal.toUpperCase();
                      }
                      x++;
                  }
              }
           
              function utf16to8(str) 
              {
                  var out, i, len, c;
           
                  out = "";
                  len = str.length;
                  for(i = 0; i < len; i++) 
                  {
                      c = str.charCodeAt(i);
                      if ((c >= 0x0001) && (c <= 0x007F)) 
                      {
                          out += str.charAt(i);
                      } 
                      else if (c > 0x07FF) 
                      {
                          out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
                          out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
                          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
                      } 
                      else
                      {
                          out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
                          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
                      }
                  }
                  return out;
              }
           
              return output;
        }
    }

}
</script>
<style lang="less">
.to-pay{
    height: 100%;
    width: 100%;
    background: #f5f5f5;
    h3{
        background: #feb62a;
        color: #fff;
        text-align: center;
        height: 44px;
        line-height: 44px;
        font-size: 16px;
        font-weight: normal;
    }
    .trade-info{
        padding: 25px 0;
        background: #fff;
        margin-bottom: 17px;
        text-align: center;
        h4{
            font-weight: normal;
            font-size: 25px;
            color: #333;
            span{
                font-size: 15px;
            }
        }
        p{
            margin-top: 16px;
            font-size: 12px;
            color: #999;
        }
    }
    .radio-item{
        display: flex;
        line-height: 50px;
        background: #fff;
        background-repeat: no-repeat;
        background-position: 10px center;
        background-size: 24px 22px;
        label{
            padding-left: 44px;
            flex: 1;
            span{
                font-size: 12px;
                color: #999;
            }
        }
        &.wechat{
            background-image: url(../assets/wechat@2x.png);
        }
        .mint-radio-core {
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            display: inline-block;
            background-color: #fff;
            border-radius: 100%;
            border: 1px solid #ccc;
            position: relative;
            width: 20px;
            height: 20px;
            vertical-align: middle;
            &:after{
                content: " ";
                border-radius: 100%;
                top: 5px;
                left: 5px;
                position: absolute;
                width: 8px;
                height: 8px;
                -webkit-transition: -webkit-transform .2s;
                transition: -webkit-transform .2s;
                transition: transform .2s;
                transition: transform .2s, -webkit-transform .2s;
                -webkit-transform: scale(0);
                transform: scale(0);
            }
        }
        .inp-wrapper{
            padding-right: 10px;
            width: 20px;
            input{
                width: 100%;
                height: 100%;
                display: none;
            }
            input:checked + .mint-radio-core {
                background-color: #ffaf14;
                border-color: #ffaf14;
                color: #ffaf14;
            }
            input:checked + .mint-radio-core::after {
                background-color: #fff;
                -webkit-transform: scale(1);
                transform: scale(1);
            }
        }
    }
    button{
        display: block;
        margin: 40px auto 0;
        width: 90%;
        background: #ffaf14;
        color: #fff;
        text-align: center;
        height: 44px;
        line-height: 44px;
        border-radius: 5px;
        font-size: 16px;
    }
    // 重置
    .mint-cell-wrapper{
        background-image: none;
    }
    .mint-cell{
        min-height: 52px;
    }
    .mint-cell:last-child{
        background-image: none;
    }
    .mint-radio-input:checked + .mint-radio-core{
        background-color: #ffaf14;
        border-color: #ffaf14;
        color: #ffaf14;
    }
    .mint-radio-label{
        padding: 0 10px 0 20px;
    }
    // 新增class
    .wechat .mint-cell-wrapper{
        background-image: url(../assets/wechat@2x.png);
        background-size: 24px 22px;
        background-position: left center;
    }
    .contact {
        background: #c5c5c5;
        margin-top: 15px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ToPay.vue